/**
 * Libs (rendo disponibili globalmente)
 */
import Utilities from "./lib/Utilities";
import Form from "./lib/Form";
window.Form = Form;
window.Utilities = Utilities;

var debugMode = window.ENV == 'local';


/**
 * DOM ready
 */
$(function() {
    /**
    * Delay per resize della larghezza della finestra.
    * Converte eventi multipli di resize in uno solo.
    */
    var resizeTimeout;
    $(window).data("current-width", $(window).width()).on("resize", function () {

        clearTimeout(resizeTimeout);

        resizeTimeout = setTimeout(function () {

            // se è variata la larghezza lancio evento
            if ($(window).width() != $(window).data("current-width")) {

                $(window).data("current-width", $(window).width());

                // evento custom ad uso di altre funzioni
                $(window).trigger("width_resize");

            }

        }, 500);
    });
});


/**
 * Load
 */
onPageReady(function() {

    /**
     * Init di barba
     * Deve essere incluso nella blade base!
     * L'evento "loadermanager-page_loaded" viene lanciato quando la coda
     * di LoaderManager è stata svuotata
     */
    $(document).on("loadermanager-page_loaded", function () {

        // init barba.js
        barbaInit();

        

        // rimozione loader
        setTimeout(function() {
            pageEnter();
            $('body').removeClass('loading');
        }, 200);

        //icona che segue il mouse
        initSeguiMouse();

        //ancore interne 
        updateAnchors();

        //inizializza i modal dei widgets, modal privacy e cookies
        initModal();

    });


    /**
     * Configurazione globale componenti uikit
     */
    (function() {
        // container false per modal, evita duplicazione elemento in seguito a caricamenti asincroni (barba.js)
        UIkit.mixin({
            data: {
                container: false,
            }
        }, 'modal');
    })();


    /**
     * Update necessari dopo caricamenti livewire
    */
    Livewire.hook('message.processed', function () {

        // update locomotive scroll per adeguamento contenuti
        // if(window.locomotive) {
        //     window.locomotive.resize();
        // }
        
        // scroll a eventuale messaggio di errore form
        scrollToFormError();

    });


    // scroll a eventuale messaggio di errore form, al caricamento!
    $(document).on('locomotive-init', () => scrollToFormError());
        
    
    /**
     * Fine caricamento
     */
    LoaderManager.eventComplete("site_loading");

     /**
     * Init di lazysizes
     */
     document.addEventListener('lazyloaded', function (e) {
        e.target.classList.remove('loading');
    });
    lazySizes.init();


});


/*
    UTILITIES
*/

/**
 * Pagina pronta per l'uscita del loader: DOM, font e immagini principali caricati.
 * A differenza di window.load non attende gli script esterni (analytics, cookie)
 * né le immagini sotto la piega; l'evento load resta come fallback.
 */
function onPageReady(callback) {
    var fired = false;
    function run() {
        if (!fired) {
            fired = true;
            callback();
        }
    }

    $(window).on("load", run);

    $(function() {
        var waits = [initHeroPoster()];

        if (document.fonts && document.fonts.ready) {
            // forza il layout, così i font in uso risultano già in caricamento
            document.body.offsetHeight;
            waits.push(document.fonts.ready);
        }

        $('img[fetchpriority="high"]').each(function() {
            if (!this.complete && this.decode) {
                waits.push(this.decode().catch(function() {}));
            }
        });

        Promise.all(waits).then(run, run);
    });
}

/**
 * Carica Plyr al primo utilizzo (non è incluso in vendor.js).
 * L'url arriva da window.PLYR_URL, impostato in layouts/base.blade.php.
 * Ritorna una promise risolta con la classe Plyr.
 */
var plyrPromise;
function loadPlyr() {
    if (!plyrPromise) {
        plyrPromise = new Promise(function(resolve, reject) {
            var script = document.createElement('script');
            script.src = window.PLYR_URL;
            script.onload = function() {
                resolve(window.Plyr);
            };
            script.onerror = function() {
                plyrPromise = null;
                reject();
            };
            document.head.appendChild(script);
        });
    }
    return plyrPromise;
}

/**
 * Poster del video hero, assegnato solo su desktop (su mobile il video viene rimosso).
 * Ritorna una promise risolta al caricamento dell'immagine.
 */
function initHeroPoster() {
    var video = document.querySelector('section.hero video[data-poster]');
    if (!video || checkMobile()) {
        return Promise.resolve();
    }

    var url = video.getAttribute('data-poster');
    video.removeAttribute('data-poster');
    video.setAttribute('poster', url);

    return new Promise(function(resolve) {
        var img = new Image();
        img.onload = img.onerror = resolve;
        img.src = url;
    });
}

function checkMobile() {
    if ($(window).width() > 959) {
        return false;
    } else {
        return true;
    }
}

function checkTouch() {
    if ($('html').hasClass('touch')) {
        return true;
    } else {
        return false;
    }
}

//controllo se si è su IOS
function checkIos(){
    var
        is_ios = /iP(ad|od|hone)/i.test(window.navigator.userAgent)
        //,is_safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if ( is_ios ) {
        return true;
    } 
}




//icona che segue il mouse
var cursor;
function initSeguiMouse() {
    if ($('html').hasClass('no-touch')) {
        //rollover con icona che segue il cursore 
        cursor = $(".myCursor");
        var $mouseX = 0,
            $mouseY = 0;
        var $xp = 0,
            $yp = 0;

        $(document).on("mousemove", function (e) {
            $mouseX = e.clientX + 25;
            $mouseY = e.clientY + 25;
        });

        var $loop = setInterval(function () {
            $xp += (($mouseX - $xp) / 5);
            $yp += (($mouseY - $yp) / 5);
            cursor.css({ left: $xp + 'px', top: $yp + 'px' });
            
        }, 30);

        updateSeguiMouse();

    }
}
function updateSeguiMouse() {

    if ($('html').hasClass('no-touch')) {
        
        cursor.css({ top: '50vh' });
        
        //play video
        $(".hover-play").on("mouseenter", function () {
            cursor.addClass("play");
        });
        $(".hover-play").on("mouseleave", function () {
            cursor.removeClass("play");
        });


        //plus
        $(".hover-plus").on("mouseenter", function () {
            cursor.addClass("cursor-plus");
        });
        $(".hover-plus").on("mouseleave", function () {
            cursor.removeClass("cursor-plus");
        });

        //next
        $(".hover-next").on("mouseenter", function () {
            cursor.addClass("cursor-next");
        });
        $(".hover-next").on("mouseleave", function () {
            cursor.removeClass("cursor-next");
        });
        //prev
        $(".hover-prev").on("mouseenter", function () {
            cursor.addClass("cursor-prev");
        });
        $(".hover-prev").on("mouseleave", function () {
            cursor.removeClass("cursor-prev");
        });
        
        // //googleMaps
        // $(".hover-map").on("mouseenter", function () {
        //     cursor.addClass("cursor-map");
        // });
        // $(".hover-map").on("mouseleave", function () {
        //     cursor.removeClass("cursor-map");
        // });
    }
}



/**
 * Gestione ancore
 * - scroll all'elemento corrispondente al click
 */
function updateAnchors() {
    //sostituisce le ancore in pagina con funzione locomotiveScroll
    $(document).off('click', 'a.anchor').on('click', 'a.anchor', function (e) {
        var anchor = $(this).attr('href');
        var myOffset = $(this).attr('data-scroll-offset');
        if (myOffset == null) {
            myOffset = 0;
        }
        if (anchor != '' && anchor.startsWith('#')) {
            e.preventDefault();
            scroll.scrollTo(anchor, { duration: 500, offset: myOffset });
        }
    }); 
}




/**
 * Scroll al primo messaggio di errore di un form
 */
function scrollToFormError()
{
    // se ho dei messaggi di validazione di un form, scrollo al primo messaggio
    if (!$('form .field__error').length) {
        return;
    }

    if(window.locomotive) {
        window.locomotive.resize();
        window.locomotive.scrollTo($('form .field__error').eq(0)[0], {
            offset: -200 // valore empirico per considerare altezza header sticky
        });
    }
}


/**
 * Funzione di uscita pagina
 */
function pageExit(callback)
{   
   if(debugMode){console.log("-----page EXIT")}
      // porto in primo piano prima di iniziare animazione
      $("#page_loader").css({
        zIndex: 100 // sotto all'header!
    });
    
    //animazione in uscita dalla pagina (il loader entra)     
    $( "#page_loader" ).animate({opacity:1}, 500, function() {
       // Animation complete

       scroll.destroy();

       if (callback && typeof(callback) == 'function') {
           callback();
       }
   });
}

/**
 * Funzione di entrata pagina
 */
function pageEnter(callback) {

    //aggiorna i link che aprono e popolano il modal
    updateModal();

    //animazione in entrata della pagina (uscita del loader)
    $( "#page_loader" ).animate({opacity: "0"}, 500, function() {

        // Animation complete        
        // porto sotto per poter interagire con pagina
        $("#page_loader").css({
            zIndex: -1,
        });
        if (callback && typeof(callback) == 'function') {
            callback();
        }
        
    })

    //inizializzo locomotive scroll
    locomotiveInit();
    
    setTimeout(function () { 
        //gestione dell'header positivo o negativo
        if ($('.contents').attr('data-header') == 'negative') {
            $('body').addClass('negative');
        } else {
            $('body').removeClass('negative');
        }

        var activeNamespace = $('body').attr('data-namespace');
        //gestione active del menu
        $('header .col-menu li').each(function (index) {
            $(this).removeClass('uk-active');
            if($(this).attr('data-namespace')==activeNamespace){
                $(this).addClass('uk-active');
            }
        });

        initVideoCorporate();

    }, 50);


}

/**
 * Gestione caricamento asincrono
 */

function barbaInit() {

    // controllo disponibilità barba
    if (typeof (barba) === "undefined") {
        return console.log("barba non disponibile");
    }

    var intervalSliderHome;

    barba.init({
        debug: window.ENV === 'local',
        logLevel: window.ENV === 'local' ? 'debug' : 'error',
        timeout: 5000,
        cacheIgnore: window.ENV === 'production', // da usare in combinazione con window.livewire.rescan() dopo la transizione (v. sotto)
        transitions: [{
            name: 'default-transition',
            beforeLeave(data) {

                
                // attendi finchè loader entra prima di lasciare la pagina
                const done = this.async();

                // qui posso fare altre cose.....
                return pageExit(function () {
                    return done();
                });


            },
            leave(data) {

               //scrollo in cima               
               scroll.scrollTo(0, {immediate:true});

               setTimeout(function() {
                   $('body').removeClass('menuOpen');
                   $('header').removeClass('menuOpen');
               }, 50);

            },
            afterLeave(data) {
            
                //rimuovo tutte le classi della pagina precedente
                $("body").removeClass (function (index, className) {
                    return (className.match (/(^|\s)page-\S+/g) || []).join(' ');
                });
                
            },
            beforeEnter(data) {

            },
            enter(data) {

            },
            afterEnter(data) {

                //aggiorno icona che segue il mouse
                updateSeguiMouse();


                updateDom(data, function () {
                    pageEnter();
                });

                // rebind degli eventi livewire
                window.livewire.rescan();

            }
        }

        ], // transitions array
        views: [
            {

                //homepage
                namespace: 'homepage',
                afterEnter(data) {

                    //var heroSlideshow;


                    //setTimeout(function() {

                        if(checkMobile()){
                            //su mobile 
                            //HERO - rimuovo il video 
                            $('section.hero div.video').remove();
                            $('section.hero #videoCorporate').remove();
                            
                        } else {
                            //su desktop, rimuovo l'immagine mobile e gestisco il video loop
                            $('section.hero .img-mobile').remove();

                            //poster del video (serve quando si arriva in home con barba)
                            initHeroPoster();

                            //se non è disponibile l'autoplay, sostituisce il video loop con l'immagine poster
                            const videoEl = document.querySelector('video');
                            if(videoEl){
                                videoEl.play().then(() => {
                                    //l'autoplay funziona  
                                }).catch((error) => {
                                    //console.log("IN questo browser non è attivo l'autoplay, sostituisco con un'immagine");
                                    $('video').each(function (index) {
                                        var urlImg = $(this).attr('poster');
                                        if(urlImg != null && urlImg != undefined){
                                            //creo elemento img
                                            var img = document.createElement('img');
                                            img.src = urlImg;
                                            img.setAttribute('alt', 'poster');
                                            img.setAttribute('class', 'poster'); 
                                            //sostituisco il tag video con l'img
                                            $(this).replaceWith(img);
                                        }
                                    });

                                });
                            }
                        }
                        
                        var tempo = 2000;
                        if(checkMobile()){
                            tempo = 3000;
                        }
                        //HERO - slider dei testi
                        const nTesti = $('section.hero .slider span').length;
                        var active = 1; 
                        if(nTesti>0){
                            intervalSliderHome = setInterval(function(){
                                //nascondo l'item corrente
                                $('section.hero .slider span.active').addClass('out');
                                //seleziono il successivo
                                active++;
                                if(active>nTesti){
                                    active=1;
                                }
                                setTimeout(function() {
                                    //rimuovo classi al precedente
                                    $('section.hero .slider span').removeClass('out active');
                                    //visualizzo successivo
                                    $('section.hero .slider span:nth-child('+active+')').addClass('active');
                                    //su mobile, faccio avanzare lo slider con l'immagine relativa al testo
                                    // if(checkMobile()){
                                    //     heroSlideshow.show(active-1);
                                    // }

                                }, 250);

                            }, tempo);
                        }

                        //progetti (su mobile rimuovo la griglia, e inizializzo uno slider)
                        initSliderMobile();
                        
                        //slider focus
                        var animazione = "push";
                        if(checkMobile()){
                            animazione = "pull";
                        }
                        var focusSlideshow = UIkit.slideshow($('section.focus .slideshow'), {
                            animation: animazione,
                            ratio: false,
                            maxHeight: 950
                        });
                        //slider focus - gestione positivo/negativo sul nav
                        var $slideItem = $('section.focus .slideshow li');
                        $slideItem.on('beforeitemshow', function(){
                            if($(this).hasClass('negativo')){
                                $("section.focus .slideshow").addClass('negativo');
                                $("section.focus .nav .prev").addClass('white');
                                $("section.focus .nav .next").addClass('white');
                            } else {
                                $("section.focus .slideshow").removeClass('negativo');
                                $("section.focus .nav .prev").removeClass('white');
                                $("section.focus .nav .next").removeClass('white');
                            }
                        });
                        
                    //}, 200);

                    
                },beforeLeave(data) {
                    clearInterval(intervalSliderHome);
                }

            }, {
                namespace: 'progetti',
                beforeEnter(data) {

                    //inizializzo i filtri delle tipologie di progetto
                    var filtri = UIkit.filter($('section.lista'), {
                        target: '.js-filter'
                    });

                    UIkit.util.on($('.filtri li'), 'click', function () {
                        if(!$(this).hasClass('uk-active')){
                            var offsets = $(this).position();
                            var w = $(this).width();
                            $('.reset').width(w);
                            $('.reset').css('left', offsets.left);
                        }
                    });



                }
            }, {
                namespace: 'progetto',
                beforeEnter(data) {


                    setTimeout(function() {
                        //progetti (su mobile rimuovo la griglia, e inizializzo uno slider)
                        initSliderMobile();

                    }, 200);

                }
            }, {
                namespace: 'servizi',
                beforeEnter(data) {


                    setTimeout(function() {

                        //inizializzo accordion + slider (sincronizzati)
                        var myOption = {
                            animation: 'fade',
                            draggable: false,
                            ratio: false,
                            minHeight: 750,
                            maxHeight: 750
                        }
                        if(checkMobile()){
                            myOption = {
                                animation: 'fade',
                                draggable: false,
                                ratio: false,
                                minHeight: 350,
                                maxHeight: 500
                            }
                        }
                        var slideshowServizi = UIkit.slideshow($('section.lista .slideshow'), myOption);
                        var accordionServizi = UIkit.accordion($('section.lista .accordion'));
                        var $accordionItem = $('section.lista .accordion li');
                        $accordionItem.on('show', function(){
                            slideshowServizi.show($(this).attr('rel'));
                        });

                    }, 200);

                }
            }, {
                namespace: 'azienda',
                beforeEnter(data) {

                    setTimeout(function() {

                        //inizializzo slider timeline
                        var myOption = {
                            animation: 'slide',
                            draggable: true,
                            //minHeight: 450,
                            //finite:true
                        }
                        var slideshowTimeline = UIkit.slideshow($('section.timeline .slideshow'), myOption);
                        
                        //scrivo la data nel nav
                        setTimeout(function() {
                            $("section.timeline .uk-slideshow-items li").each(function(index) {
                                var anno = $(this).attr('data-rel');
                                $("section.timeline .uk-slideshow-nav li:nth-child("+(index+1)+")").append("<span>"+anno+"</span>");
                            });
                        }, 50);


                    }, 200);

                }

            },{
                namespace: 'contatti',
                beforeEnter(data){

                    setTimeout(function() {
                        //initGoogleMap();
//                        google.maps.event.addDomListener(window, 'load', initGoogleMap);
                    }, 200);
            
                }
            }

        ],
        requestError: (trigger, action, url, response) => {

            // forzo a seguire le url 404 per visione del messaggio
            if (action == 'click' && response.status == 404) {
                window.location.href = url;
                return false;
            }
            // rebind degli eventi livewire
            window.livewire.rescan();


        },
        preventRunning: true
    });
}

//MODAL WIDGETS
function chiudiModal(){
    $("div#widgetModal").removeClass("visibile");
    $("div#widgetModal .contenuto").empty();
    $("div#widgetModal").addClass("nascosto");
}
function initModal(){
    //btn chiudi
    $("div#widgetModal .uk-close").on('click', function (e) {
        chiudiModal();
    });
    $("div#widgetModal .bg").on('click', function (e) {
        chiudiModal();
    });

    //click sul footer che aprono i modal privacy e cookies
    const link = document.querySelector('#btn-privacy');
    link.addEventListener('click', function(event) {
        event.preventDefault();
        // Apri il modal
        UIkit.modal('#modal-privacy').show();
        // Seleziona l'iframe
        const iframe = document.getElementById('privacy-iframe');
        // Sostituisci l'attributo src con il contenuto di data-src
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
    });
    const linkCookie = document.querySelector('#btn-cookies');
    linkCookie.addEventListener('click', function(event) {
        event.preventDefault();
        // Apri il modal
        UIkit.modal('#modal-cookies').show();
        // Seleziona l'iframe
        const iframe = document.getElementById('cookies-iframe');
        // Sostituisci l'attributo src con il contenuto di data-src
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
    });
    /*
    // Seleziona il link
    
    
    // Aggiungi un event listener al link
    link.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Apri il modal
        UIkit.modal('#modal-privacy').show();
        
        // Seleziona l'iframe
        const iframe = document.getElementById('privacy-iframe');
        
        // Sostituisci l'attributo src con il contenuto di data-src
        iframe.setAttribute('src', iframe.getAttribute('data-src'));
    });
    */


}
function updateModal(){    
    $('a.myModal').on('click', function (e) {
        e.preventDefault();
        var urlVideo = $(this).attr("data-video-url");
        var tipo = $(this).attr("data-video-tipo");
        var contenuto;
        if(tipo=="youtube"){
            contenuto = "<div><iframe src='https://www.youtube-nocookie.com/embed/"+ urlVideo +"?rel=0&amp;version=3&amp;autoplay=1&amp;mute=1&amp;showinfo=0&amp;modestbranding=1' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share' allowfullscreen width='1920' height='1080'></iframe></div>";
        } else if(tipo=="vimeo"){
            contenuto = "<div><iframe src='https://player.vimeo.com/video/"+ urlVideo +"?autoplay=1&color=ffffff&title=0&byline=0&portrait=0&muted=1' width='1920' height='1080' frameborder='0' allow='autoplay; fullscreen; picture-in-picture' allowfullscreen></iframe></div>";
        }

        $("div#widgetModal").removeClass("nascosto");
        setTimeout(function() {
            $("div#widgetModal").addClass("visibile");
        }, 250);

        //lo popolo quando Plyr è disponibile, così il video compare già con il player
        loadPlyr().then(function(Plyr) {
            //il modal potrebbe essere già stato chiuso mentre Plyr veniva caricato
            if ($("div#widgetModal").hasClass("nascosto")) {
                return;
            }

            $("div#widgetModal .contenuto").append(contenuto);

            const player = new Plyr($("div#widgetModal .contenuto > div"), {
                controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, autoplay:true},
                autoplay:true,
            });
        });

    });

}
// function initGoogleMap() {
    
//     // Basic options for a simple Google Map
//     // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
//     var mapOptions = {
//         // How zoomed in you want the map to start at (always required)
//         zoom: 11,

//         // The latitude and longitude to center the map (always required)
//         center: new google.maps.LatLng(45.336141, 10.74902), // New York

//         // How you would like to style the map. 
//         // This is where you would paste any style found on Snazzy Maps.
//         styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
//     };

//     // Get the HTML DOM element that will contain your map 
//     // We are using a div with id="map" seen below in the <body>
//     var mapElement = document.getElementById('map');

//     // Create the Google Map using our element and options defined above
//     var map = new google.maps.Map(mapElement, mapOptions);
    
//     // Let's also add a marker while we're at it
//     var marker = new google.maps.Marker({
//         position: new google.maps.LatLng(45.336141, 10.74902),
//         map: map,
//         title: 'Snazzy!'
//     });
// }


function onLocoScroll({ scroll, limit, velocity, direction, progress }) {
    if(direction==1) {
        if(scroll > 100){
            $('body').addClass("scrolling");
        }
    } else{
        if(scroll < 100){
            $('body').removeClass("scrolling");
        }
    }
}

/**
 * init locomotive scroll
*/
var scrollPos = 0;
let scroll;
function locomotiveInit() {

    let options = {     
        lerp: 1,
        duration: 1,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        normalizeWheel: true,
        autoResize: true,
        scrollCallback: onLocoScroll,
        //easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    }

    var direction;

    scroll = new LocomotiveScroll(options);

   

    // memorizzo per accesso in altri punti
    window.locomotive = scroll;

    // ad uso di altri script
    $(document).trigger("locomotive-init");

    /**
     * Update locomotive dopo messaggi livewire
     * (per adeguamento contenuti)
    */
    // Livewire.hook('message.processed', function () {
    //     //window.locomotive.update();
    //     window.locomotive.resize();
    // });


    /**
     * Evento di render di un form livewire,
     * scroll al primo messaggio di errore
     * (emettere l'evento nel metodo render di un form gestito con Livewire)
     */
    window.addEventListener('form:rendered', event => {
        let form = $(event.target);
        let offset = -200; // valore empirico per considerare altezza header

        if (form.find('.field__error').length) {
            window.locomotive.resize();
            window.locomotive.scrollTo(form.find('.field__error').eq(0)[0], {
                offset: offset
            });
        } else if($('.form_response').length) {
            window.locomotive.resize();
            window.locomotive.scrollTo($('.form_response')[0], {
                offset: offset
            });

        }
    });

}

//SU MOBILE - inizializzo uno slider al posto della griglia
function initSliderMobile(){

    if(checkMobile()){
        $('.sliderMobile-gridDesk .lista').removeClass('uk-grid').addClass('uk-slideshow-items');

        //rimuovo il bottone view all (in home)
        if($('.sliderMobile-gridDesk .lista li.viewAll').length){
            $('.sliderMobile-gridDesk .lista li.viewAll').remove();
        }

        //inizializzo
        var slideProgetti = UIkit.slideshow($('.sliderMobile-gridDesk'), {
            animation: 'pull',
            autoplay: true,
            minHeight: 480
        });
    }
}

//gestione del modal che contiene il video corporate
//fatto manualmente per via dell'audio e il cambio pagina
function initVideoCorporate(){
    var myPlyr;
    var isOpen = false;
    if($('.btnPlayCorporate').length){
        //init toggle su video corporate
        var modalVid =  UIkit.toggle($('.btnPlayCorporate'), {
            target: '#videoCorporate'
        });

        //popolo l'iframe con il video corporate e inizializzo PLYR (caricato al primo utilizzo)
        $('#videoCorporate').on('beforeshow', function(){
            isOpen = true;
            loadPlyr().then(function(Plyr) {
                //il modal potrebbe essere già stato chiuso mentre Plyr veniva caricato
                if (!isOpen) {
                    return;
                }

                var mySrc = $("#videoCorporate .videoWrap iframe").attr("data-src");
                $("#videoCorporate .videoWrap iframe").attr("src", mySrc);

                //player video su modal
                myPlyr = new Plyr($("#videoCorporate .videoWrap"), {
                    controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
                    youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, autoplay:true},
                    autoplay:true,
                });
            });
        });

        //quando viene chiuso svuoto il modal, lo svuoto per fermare l'audio
        $('#videoCorporate').on('hidden', function(){
            isOpen = false;
            if (myPlyr) {
                myPlyr.destroy();
                myPlyr = null;
            }
            $("#videoCorporate .videoWrap iframe").attr("src", "");
        });
    }
    
}

/**
 * Aggiorna il dom.
 * Sono possibili diverse strategie (combinarle a bisogno):
 * 1. sostituire in toto l'head (questo scatena anche anche esecuzione degli script, anche inline)
 * 2. sostituire tag specifici nell'head
 * 3. - inserire script/style specifici per la nuova pagina nel container di quest'ultima.
 *    - caricare gli script in ajax, mentre eventuali tag <style> presenti nel container verranno automaticamente valutati dal browser
 * 
 * Con gli stessi sistemi si possono aggiornare elementi al di fuori del container di barba
 */
function updateDom(data, callback) {

    var html = data.next.html;
    var newHeadHtml = html.match( /<head[\s\S]*?>[\s\S]*?<\/head>/gi )[0];

    // true mantiente gli script
    var $newPageHead = $.parseHTML(newHeadHtml, document, true);

    /**
     * Aggiorno namespace di body 
     */
    $("body").attr("data-namespace", data.next.namespace);
    
    /**
     * aggiorno html altri elementi
     * In ogni elemento dell'array inserire:
     * - o il selettore completo
     * - o il selettore + l'attributo che si vuole rimpiazzare
     */
    [
        'head'
    ].forEach((selector) => {

        let realSelector = Array.isArray(selector) ? selector[0] : selector;
        let attribute = Array.isArray(selector) ? selector[1] : null;

        // recupero elemento nel nuovo html in arrivo
        let el = $(realSelector, $(data.next.html));

        // no lambda qui!
        $(realSelector).each(function() {
            if(attribute !== null) {
                // rimpiazzo attributo
                $(this).attr(attribute, el.attr(attribute));
            } else {
                // rimpiazzo contenuto html nella pagina
                $(this).html(el.html());
            }
        });

    });


    /**
     * 1. aggiornamento in toto dell'head
     */
    //$("head").html(newHeadHtml);

    
    /**
     * 2. aggiornamento di script specifici nell'head
     */
    $newPageHead = $( '<head />' ).html($newPageHead);
    var headTags = [
        "meta[name='keywords']",
        "meta[name='description']",
        "meta[property^='og']",
        "meta[name^='twitter']",
        "meta[itemprop]",
        "link[itemprop]",
        "link[rel='prev']",
        "link[rel='next']",
        "link[rel='canonical']",
        "link[rel='alternate']"
    ].join( ',' );
    
    $( 'head' ).find( headTags ).remove();
    
    $newPageHead.find( headTags ).appendTo( 'head' );
    /**
     * 2. // fine
     */


    /**
     * 3. Caricamento degli script presenti nel container della nuova pagina
     */
    $(data.next.container).find('script').each(function (i, script) {
        var $script = $(script);

        // script linkato
        if($script.attr('src')) {
            $.getScript($script.attr('src'));
        // script inline
        } else {
            $script.appendTo('[data-barba="container"]');
        }
        
    });
    /**
     * 3. // fine
     */

    if(callback && typeof(callback) == 'function') {
        return callback();
    }

    return true;
    
}